import { getCartUpdatedEventName } from "utils/cart";

const useCart = () => {
  const addToCart = (item) => {
    const existingItems = JSON.parse(localStorage.getItem("babyShop")) || [];

    const key = item.item_id || item.title;
    const existingIndex = existingItems.findIndex(
      (p) => (p.item_id || p.title) === key,
    );

    const firstVariant = item.variants?.[0] || {};

    const colorArray = item.color
      ? item.color.split(",").map((s) => s.trim())
      : [];

    const sizeArray = item.size
      ? item.size.split(",").map((s) => s.trim())
      : [];

    const selectedColor = colorArray[0] || "";
    const selectedSize = sizeArray[0] || "";
    const selectedTitle = firstVariant.title || "";
    const selectedPrice = firstVariant.flashPrice || 0;

    if (existingIndex !== -1) {
      existingItems[existingIndex] = {
        ...existingItems[existingIndex],
        quantity: (existingItems[existingIndex].quantity || 1) + 1,
        selectedColor,
        selectedSize,
        selectedTitle,
        selectedPrice,
      };
    } else {
      existingItems.push({
        ...item,
        quantity: 1,
        selectedColor,
        selectedSize,
        selectedTitle,
        selectedPrice,
        selectedVariant: firstVariant,
      });
    }

    localStorage.setItem("babyShop", JSON.stringify(existingItems));
    window.dispatchEvent(
      new CustomEvent(getCartUpdatedEventName(), {
        detail: {
          count: existingItems.reduce(
            (sum, item) => sum + (item.quantity || 1),
            0,
          ),
        },
      }),
    );
  };

  return { addToCart };
};

export default useCart;
